import React from 'react'
import SHeaderbar from '../Components/Navbar/Header.js'
import SFooterbar from '../Components/Navbar/Footer.js'
import StudentCourseList from '../Components/Student/StudentCourseList'
import Leftbar from '../Components/Sidebar/Leftbar'

function StudentCourses() {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#FCFCFC' }}>
      <Leftbar />
      <div
        style={{
          flex: 1,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          padding: 0,
          boxSizing: 'border-box',
        }}
      >
        <div style={{ flex: 1, padding: 24, minHeight: 0 }}>
          <SHeaderbar />
          <StudentCourseList />
          <SFooterbar />
        </div>
      </div>
    </div>
  )
}

export default StudentCourses

